module.exports = __webpack_public_path__ + "static/media/chrome.8e532622.svg";